import { render, staticRenderFns } from "./ShortcutHelpDialog.vue?vue&type=template&id=650002f3&scoped=true"
import script from "./ShortcutHelpDialog.vue?vue&type=script&lang=js"
export * from "./ShortcutHelpDialog.vue?vue&type=script&lang=js"
import style0 from "./ShortcutHelpDialog.vue?vue&type=style&index=0&id=650002f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650002f3",
  null
  
)

export default component.exports